<template>
  <div class="home">
    <!-- 访问人数 -->
    <el-card class="box-card" shadow="never">
      <div slot="header" class="clearfix">
        <div class="cart-title">
          <img src="@/assets/image/l3.png" width="25" height="25" />
          <span>访问人数</span>
        </div>
        <span>( 单位: &nbsp;人 )</span>
      </div>
      <div class="cart-body">
        <div v-for="(item, index) in viewers" :key="index">
          <p class="viewer-data">{{ item.data }}</p>
          <p class="viewer-title">{{ item.title }}</p>
        </div>
      </div>
    </el-card>
    <div class="box-card-flex">
      <!-- 穴位一览 -->
      <el-card class="box-card box-card1" shadow="never">
        <div slot="header" class="clearfix">
          <div class="cart-title">
            <img src="@/assets/image/l2.png" width="25" height="25" />
            <span>穴位一览</span>
          </div>
        </div>
        <div class="cart-body-acupoint">
          <div class="acupoint" v-for="(item, index) in acupoint" :key="index">
            <div class="acupoint-title">{{ item.title }}</div>
            <div class="acupoint-text">
              <span>{{ item.text1 }}</span>
              <span>{{ item.data1 }}</span>
            </div>
            <div class="acupoint-text">
              <span>{{ item.text2 }}</span>
              <span>{{ item.data2 }}</span>
            </div>
          </div>
        </div>
      </el-card>
      <!-- 病症一览 -->
      <el-card class="box-card box-card1" shadow="never">
        <div slot="header" class="clearfix">
          <div class="cart-title">
            <img src="@/assets/image/l1.png" width="25" height="25" />
            <span>病症一览</span>
          </div>
        </div>
        <div class="cart-body-acupoint malady">
          <div class="acupoint" v-for="(item, index) in malady" :key="index">
            <div class="acupoint-title">{{ item.title }}</div>
            <div class="acupoint-text">
              <span>{{ item.text1 }}</span>
              <span>{{ item.data1 }}</span>
            </div>
            <div class="acupoint-text">
              <span>{{ item.text2 }}</span>
              <span>{{ item.data2 }}</span>
            </div>
          </div>
        </div>
      </el-card>
    </div>
  </div>
</template>

<script>
import "echarts/theme/macarons.js";
import { total } from "@/api/home";
export default {
  name: "lock",
  data() {
    return {
      viewers: [
        { title: "今日访客", data: 0 },
        { title: "昨日访客", data: 0 },
        { title: "本月访客", data: 0 },
        { title: "访问总数", data: 0 },
      ],
      acupoint: [
        {
          title: "穴位数量",
          text1: "新增穴位",
          data1: 0,
          text2: "穴位总数",
          data2: 0,
        },
        {
          title: "访问量",
          text1: "今日访问",
          data1: 0,
          text2: "访问总数",
          data2: 0,
        },
        {
          title: "转发数量",
          text1: "今日转发",
          data1: 0,
          text2: "转发总数",
          data2: 0,
        },
      ],
      malady: [
        {
          title: "病症案例",
          text1: "新增案例",
          data1: 0,
          text2: "案例总数",
          data2: 0,
        },
        {
          title: "访问量",
          text1: "今日访量",
          data1: 0,
          text2: "访问总数",
          data2: 0,
        },
        {
          title: "转发数量",
          text1: "今日转发",
          data1: 0,
          text2: "转发总数",
          data2: 0,
        },
      ],
    };
  },
  created() {
    this.$store.dispatch("fullscreenLoading", true);
  },
  mounted() {
    this.getData();
  },
  methods: {
    getData() {
      total().then((res) => {
        if (!res.data) return;
        // 访问人数
        this.viewers[0].data = res.data.todayVisitorCount || 0;
        this.viewers[1].data = res.data.yesterdayVisitorCount || 0;
        this.viewers[2].data = res.data.thisMonthVisitorCount || 0;
        this.viewers[3].data = res.data.totalVisitorCount || 0;
        // 穴位一览
        this.acupoint[0].data1 = res.data.todayNewAcupointCount || 0;
        this.acupoint[0].data2 = res.data.acupointCount || 0;
        this.acupoint[1].data1 = res.data.todayAcupointAccessCount || 0;
        this.acupoint[1].data2 = res.data.totalAcupointAccessCount || 0;
        this.acupoint[2].data1 = res.data.todayAcupointTransmitCount || 0;
        this.acupoint[2].data2 = res.data.totalAcupointTransmitCount || 0;
        // 病症一览
        this.malady[0].data1 = res.data.todayNewIllnessCount || 0;
        this.malady[0].data2 = res.data.illnessTotalCount || 0;
        this.malady[1].data1 = res.data.todayIllnessAccessCount || 0;
        this.malady[1].data2 = res.data.totalIllnessAccessCount || 0;
        this.malady[2].data1 = res.data.todayIllnessTransmitCount || 0;
        this.malady[2].data2 = res.data.totalIllnessTransmitCount || 0;
        this.$store.dispatch("fullscreenLoading", false);
      });
    },
  },
};
</script>

<style scoped src="./style/home.css"></style>
<style scoped></style>
